module.exports = __webpack_public_path__ + "static/media/click3.5cc40ee0.ogg";